import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';
const {
GET_SUPERVISOR_ALERT_REQUEST_SETTING,
  GET_SUPERVISOR_ALERT_SUCCESS_SETTING,
  GET_SUPERVISOR_ALERT_FAILURE_SETTING,
  GET_SUPERVISOR_ALERT_LOADING_SETTING,
  GET_SUPERVISOR_ALERT_RESET_SETTING,
} = departmentDashboard;

function* getSupervisorAlertSetting(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_SUPERVISOR_ALERT_LOADING_SETTING });
    const response = yield call(departmentDashboardService.getSupervisorAlertSetting, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_SUPERVISOR_ALERT_SUCCESS_SETTING, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_SUPERVISOR_ALERT_FAILURE_SETTING, payload: error });
  }
}

function* getSupervisorAlertSettingSaga() {
  yield takeEvery(GET_SUPERVISOR_ALERT_REQUEST_SETTING, getSupervisorAlertSetting);
}

export default getSupervisorAlertSettingSaga;
